import * as SerializerLib from "jsonapi-serializer";

import { serializeError } from "../base.serializer";

const JSONAPISerializer = SerializerLib.Serializer;

const opts = {
  attributes: ["email", "username"]
};

export const serialize = (data) => {
  try {
    const Serializer = new JSONAPISerializer("questions", opts);
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};
